<template>
    <SectionViewLayout
      title='settings.housekeeper.title_results'
      :content_state='content_state'
      content_class="house-keeper"
      close_class="close"
      @actionClose="onActionClose()"
    >
        <template #content>
          <div>
              <h3>
                {{Language.say('settings.housekeeper.results_header')}}
              </h3>

              <p>
                {{Language.say('settings.housekeeper.results_text_1')}}
              </p>

              <p class="alert" v-if="housekeeper_options.action === 'move'">
                <i class="fas fa-exclamation-circle"></i>
                <span>{{Language.say('settings.housekeeper.results_move_1')}}</span>
                <strong>{{housekeeper_options.messages.length}}</strong>
                <span>{{Language.say('settings.housekeeper.results_move_2')}}</span>
                <strong>{{housekeeper_options.folder.name}}</strong>
                <span>{{Language.say('settings.housekeeper.results_move_3')}}</span>
                <strong>{{housekeeper_options.destination.name}}</strong>
              </p>

              <p class="alert" v-else-if="housekeeper_options.action === 'delete_perm'">
                <i class="fas fa-exclamation-circle"></i>
                <span>{{Language.say('settings.housekeeper.results_delete_1')}}</span>
                <strong>{{housekeeper_options.messages.length}}</strong>
                <span>{{Language.say('settings.housekeeper.results_delete_2')}}</span>
                <strong>{{housekeeper_options.folder.name}}</strong>

              </p>
          </div>
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import {ref, reactive}              from 'vue';
  import {defineEmits, defineProps}   from 'vue';
  import {onBeforeMount}              from 'vue';
  import SectionViewLayout            from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import FoldersController            from '@/js/Mailboxes/FoldersController';
  import Language                     from '@/js/Shared/Language/Language';
  import ContentState                 from '@/js/Shared/State/ContentState';
  import SAPOMailConfig               from '@/SAPOMailConfig';

  const emit = defineEmits([
    'houseKeeperResultsClose'
  ])

  const props = defineProps({
    housekeeper_options   : {},
    housekeeper_controller: {},
  })

  const content_state = reactive(new ContentState());

  content_state.onErrorRetry(async () => {
    await addHouseKeeperJob();
  });

  onBeforeMount(async () => {
    if (await addHouseKeeperJob() === false) {
      return;
    };
  })

  const onActionClose = () => {
    emit('houseKeeperResultsClose');
  }

  const addHouseKeeperJob = async () => {
    await props.housekeeper_controller.addJob(
      props.housekeeper_options,
      content_state,
    );
  }
</script>
